
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 9" fill="currentColor">
	<g clip-path="url(#clip0_386_3275)">
		<path fill-rule="evenodd" clip-rule="evenodd"
			d="M4.16675 1.16602C6.09975 1.16602 7.66675 2.73302 7.66675 4.66602C7.66675 6.59902 6.09975 8.16602 4.16675 8.16602C2.23375 8.16602 0.666748 6.59902 0.666748 4.66602C0.666748 2.73302 2.23375 1.16602 4.16675 1.16602ZM6.85661 3.14276H5.62745L5.61729 3.1449L5.60858 3.1505L3.95965 4.74892V3.16901C3.95945 3.16198 3.95651 3.15532 3.95148 3.15042L3.94282 3.14476L3.93305 3.14318H2.67074C2.66378 3.14317 2.65708 3.14586 2.65206 3.15067L2.64614 3.15903L2.64376 3.16901V3.43804C2.64396 3.44506 2.64689 3.45173 2.65193 3.45662L2.66059 3.46228L2.67074 3.46425H2.94556C2.95654 3.46425 2.96623 3.47076 2.97038 3.48019L2.97254 3.49046V6.99722L6.87551 3.18751C6.87938 3.1839 6.88208 3.17918 6.88318 3.174C6.88428 3.16882 6.88374 3.16342 6.88171 3.15854C6.87965 3.15366 6.87615 3.14953 6.87165 3.14671L6.86443 3.14359L6.85661 3.14276Z" />
	</g>
</svg>
    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'UserVerified',
    }) as DefineComponent
    </script>
    